import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logIn } from "../../actions/LoginAction";
import { enumUtil } from "../../utils/Enum";
import NotificationHandler from "../../utils/NotificationHandler";
import { ServerRequestProtected } from "../../utils/ServerDataRequest";
import Loader from "../shared/Loader/Loader";
import Cookies from "js-cookie";
import isNull from "../../utils/NullChecking";
import LogoRef from '../../assets/img/logoRef.png';
import SuperSearchList from "../shared/SuperSearch/SuperSearchList";



const Login = () => {
    const API_URL = enumUtil.controller.Login
    const [isLoading, setisLoading] = useState(false);
    const [userData, setUserData] = useState({ email: "", password: "" })
    const [showPassword, setShowPassword] = useState(false);
    const [isRemember, setIsRemember] = useState(false);
    const dispatch = useDispatch();
    let navigate = useNavigate();


    const year = new Date().getFullYear();

    const handleSubmit = (event) => {
        event.preventDefault();
        setisLoading(true)
        ServerRequestProtected(API_URL + "/Login", 'post', {
            "email": userData.email,
            "Password": userData.password
        }).then((response) => {
            // setisLoading(false)

            // if(response === false){
            //     navigate("../forgotpassword", { replace: true });
            // }else{
            //     dispatch(logIn({ token: response.token }))
            //     navigate("../pms", { replace: true });
            //     response.token && Cookies.set('cookedToken', response.token, { expires: 1 });
            // }
            setisLoading(false)
            localStorage.removeItem('PatientPaymentDetails');
            if (response?.ispasswordexpired) {
                dispatch(logIn({ token: response.token }))
                response.token && Cookies.set('cookedToken', response.token, { expires: 1 });
                navigate("../RestorePassword", { replace: true });
                NotificationHandler('Your password has expired', enumUtil.enumtoaster.error)
            }
            else if (response?.required2FA) {
                navigate("../TwoFactorAuth", {
                    replace: true,
                    state: { fullResponse: response }
                });
            }
            else if (response?.requireBAA) {
                dispatch(logIn({ token: response.token }))
                response.token && Cookies.set('cookedToken', response.token, { expires: 1 });
                navigate("../changepassworBaa", {
                    replace: true,
                    state: { fullResponse: response }
                });
            }
            else {
                if (!isNull(response.url)) {
                    window.open(response.url,)
                } else {
                    if (response === false) {
                        navigate("../forgotpassword", { replace: true });
                    } else {
                        dispatch(logIn({ token: response.token }))
                        navigate("../pms", { replace: true });
                        response.token && Cookies.set('cookedToken', response.token, { expires: 1 });
                    }
                }
            }




        }).catch((error) => {
            setisLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }

  const ThemeConfiguration =  useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    const isPageLoading = !ThemeConfiguration;
    
    // const handleForget =  (data) => {

    //     // setIsLoading(true);
    //     ServerRequestProtected(API_URL + "/ForgotPassword", 'post',
    //         {
    //             Email:data+''
    //         }
    //     ).then((response) => {
    //         // setIsLoading(false)
    //         // event.preventDefault();
    //         // NotificationHandler('Email Sent Successfully', enumUtil.enumtoaster.success)
    //         // navigate("../checkemail", {
    //         //     state: { ...ForgotPasswordSaveUpdateModal }
    //         // })
    //     }).catch((error) => {
    //         // setIsLoading(false)
    //         // NotificationHandler("Invalid email address, please enter valid email. ", enumUtil.enumtoaster.error)
    //     })
    // }
    const onChangeHandler = (e) => {
        const { value, name } = e.target
        setUserData({ ...userData, [name]: value })
    }

    const handleRememberChange = (e) => {
        const { checked } = e.target;
        setIsRemember(checked);
    }

    return (
        <React.Fragment >
            {/* <>
                <div className="login">
                    <div className="d-lg-flex half">
                        <div className="bg order-1 order-md-2">
                            <img src={process.env.PUBLIC_URL + "/assets/images/v2LoginHMS.jpg"} alt="" />
                        </div>
                        <div className="contents order-2 order-md-1">
                            <div className="container">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-md-10">
                                        <div className="login-logo">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/logo-single.png"} alt="" />
                                        </div>
                                        <p className="heading xl">Login to your Account</p>
                                        <p className="text mb-4 clr-muted ">See what is going on with your bussiness.</p>
                                        <form onSubmit={handleSubmit} autoComplete="on">
                                            <div className="form-group input">
                                                <label htmlFor="">Email</label>
                                                <input onChange={onChangeHandler} required value={userData.email} name="email" type="email" className="form-control" placeholder="" autoComplete="username" />
                                            </div>
                                            <div className="form-group input mb-3 pass-check">
                                                <label htmlFor="">Password</label>
                                                <input
                                                    onChange={onChangeHandler}
                                                    required
                                                    value={userData.password}
                                                    name="password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    className="form-control"
                                                    placeholder=""
                                                    autoComplete="current-password"
                                                />

                                                {showPassword ? (
                                                    <i
                                                        onClick={() => setShowPassword(false)}
                                                        className="icon-eye"
                                                    />
                                                ) : (
                                                    <i
                                                        onClick={() => setShowPassword(true)}
                                                        className="icon-Icon-ionic-md-eye-off"
                                                    />
                                                )}
                                            </div>

                                            <div className="d-flex mb-3 align-items-center justify-content-between">
                                                <div className="form-check custom_check_box  ">

                                                </div>
                                                <span className=""><a onClick={() => navigate("../forgotpassword", { replace: true })} className="forgot-pass">Forgot Password</a></span>
                                            </div>
                                            <div className='position-relative login-btn-loader'>
                                                <input type="submit" value={`${isLoading === true ? '' : 'Log In'}`} className="btn rounded btn-orange w-100" />
                                                {isLoading === true ?
                                                    <div className='last_loader ar-small-loader'>
                                                        <div className="circle circle1"></div>
                                                        <div className="circle circle2"></div>
                                                    </div> :
                                                    null}
                                            </div>


                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="doted-text">
                    <div></div>
                    <p className="text text-center my-3">or Sign in with Email</p>
                    <div></div>
                </div>
                <p className="text text-center">Not Registered? <a href="">Create an Account</a></p>
                <input className="form-check-input" type="checkbox" id="inlineCheckbox1" checked={isRemember} onChange={handleRememberChange} />
                <label className="form-check-label" htmlFor="inlineCheckbox1">Remember Me</label>
            </> */}

            {isPageLoading ? <></> :
                <div className="ar_login-screen">
                    <div className="ar-main-screen-content w-100 d-flex align-items-center flex-column gap-25 justify-content-center">
                        <div className="login-content">
                            <div className="img-container h-auto s-70 mx-auto mb-15">
                                <img src={process.env.PUBLIC_URL + "/static/media/logox.6cdf68c22a565132379b34a478d32d8a.svg"} alt="" />
                            </div>
                            <div className="mb-2 d-flex flex-column align-items-center">
                                <p className='fs-20 heading lh-normal'>Login to Your Account</p>
                                <p className='text fs-11 color-muted lh-normal'>{ThemeConfiguration?.configuration?.login?.welcomeMessage}</p>
                            </div>
                            <form onSubmit={handleSubmit} autoComplete="on">
                                <div className="d-flex flex-column gap-20 br-bottom-1 za_br_light pb-4 mb-4">
                                    <div className="form-group mb-0 input">
                                        <label htmlFor="">Email</label>
                                        <input onChange={onChangeHandler} required value={userData.email} name="email" type="email" className="form-control" placeholder="" autoComplete="username" />
                                    </div>
                                    <div className="form-group input mb-0 pass-check">
                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                            <label htmlFor="" className="pb-0">Password</label>
                                            <span className="">
                                                <a onClick={() => navigate("../forgotpassword", { replace: true })} className="ar-dark-color font-r fs-12 heading text-decoration-none text-decoration-underline">Forgot Password?</a>
                                            </span>
                                        </div>
                                        <input
                                            onChange={onChangeHandler}
                                            required
                                            value={userData.password}
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            className="form-control"
                                            placeholder=""
                                            autoComplete="current-password"
                                        />

                                        {showPassword ? (
                                            <i onClick={() => setShowPassword(false)} className="icon-eye" />
                                        ) : (
                                            <i onClick={() => setShowPassword(true)} className="icon-Icon-ionic-md-eye-off" />)}
                                    </div>
                                    <div className='position-relative login-btn-loader'>
                                        <input type="submit" value={`${isLoading === true ? '' : 'Log In'}`} className="btn rounded btn-orange heading w-100" />
                                        {isLoading === true ?
                                            <div className='last_loader ar-small-loader'>
                                                <div className="circle circle1"></div>
                                                <div className="circle circle2"></div>
                                            </div> :
                                            null}
                                    </div>
                                </div>

                                <div className="d-flex align-items-center justify-content-center">
                                    <p className='text fs-12 color-95 '>© {year} {ThemeConfiguration?.configuration?.company?.name}. All rights reserved</p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }

            {/* <div className="ar_review_confirm_payment">
                <div className="ar_header">
                    <img src={process.env.PUBLIC_URL + "/assets/images/LogoPngNew.svg"} alt="" />
                </div>
                <div className="ar_content d-flex flex-column align-items-center justify-content-center gap-10">
                    <div className="text-center">
                        <p className="heading fs-25 balck-5-clr pb-1-5 lh-normal">Review & Confirm Payment</p>
                        <p className="text fs-13 balck-5-clr">Please review your statement details before proceeding to payment.</p>
                    </div>
                    <div className="d-flex align-items-center gap-40 py-10 my-2">
                        <div className="ar-bg-box">
                            <p className="text font-m orange-drk">Billed By</p>
                            <p className="heading text-black fs-16">MEDICARE PRACTICE</p>
                            <p className="text text-black">555 Marin St # 120 <br />  Thousand Oaks, CA, 77090</p>
                        </div>
                        <div className="ar-bg-box">
                            <p className="text font-m orange-drk">Billed To</p>
                            <p className="heading text-black fs-16">Albert, Rins <span className="text text-black">10/10/2002 (34 Y) Male</span></p>
                            <p className="text text-black">555 Marin St # 120 <br />  Thousand Oaks, CA, 77090</p>
                        </div>
                    </div>
                    <div className="">
                        <div className="ar_table  hover-scrollbar">
                            <table className="w-100">
                                <thead>
                                    <tr>
                                        <th className="heading text-white">Date of Service</th>
                                        <th className="heading text-white">Description</th>
                                        <th className="heading text-white">Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text text-black">10/29/2025</td>
                                        <td className="text text-black">ERA 02842934 Adj: 456 from copay collected</td>
                                        <td className="text text-black">$0.00</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="amount-footer mb-12">
                            <p className="text text-black"><span className="heading text-black">Amount to Pay: $12.00</span> - Please review your statement details before proceeding to payment.</p>
                        </div>

                        <div className="d-flex justify-content-end pt-10">
                            <button className="btn btn-orange px-3 h-100 fs-14 rounded py-1-5">Proceed to Payment</button>
                        </div>
                    </div>
                </div>

                <div className="hs_footer d-flex flex-column justify-content-center align-items-center">
                    <p className="heading ar-light-color lh-24">STAR HEALTHCARE TECHNOLOGIES,  All Rights Reserved.</p>
                    <p className="text ar-light-color lh-24">
                        <a href="https://starhealthcare.co/PrivacyPolicy" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">Privacy Policy</a> | <a href="https://starhealthcare.co/BusinessAssociateAgreement" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">BAA</a>.
                    </p>
                </div>

 
            </div> */}

            {/* <div className="ar_review_confirm_payment">
                <div className="ar_header">
                    <img src={process.env.PUBLIC_URL + "/assets/images/LogoPngNew.svg"} alt="" />
                </div>
                <div className="ar_content d-flex flex-column align-items-center justify-content-center gap-10">
                    <div className="text-center">
                        <p className="heading fs-25 balck-5-clr pb-1-5 lh-normal">Add Payment Details</p>
                        <p className="text fs-13 balck-5-clr">Enter your card details below to complete your payment securely.</p>
                    </div>
                    <div className="">
                        <div className="py-10 my-2 w-444px d-flex flex-column gap-15">
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Amount to Pay</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                    disabled
                                />
                            </div>
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Card Number</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>
                            <div className="d-flex align-items-center ">
                                <p className="text text-black font-m text-nowrap">Card Type</p>
                                <div className='d-flex gap-4 align-items-center justify-content-end w-100'>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/MasterCard.svg' alt="" />
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/Visa.svg' alt="" />

                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/AmericanExpress.svg' alt="" />

                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0"
                                                name='IsAutoSubmittion'
                                                id='IsAutoSubmittion'
                                            />
                                        </div>
                                        <img src='/assets/images/UnionPay.svg' alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center gap-12">
                                <div className='input mb-0 w-100'>
                                    <p className="text text-black font-m pb-3px">Expiration Date</p>
                                    <input type="text"
                                        className='form-control'
                                        name="SectionName"
                                        id="SectionName"
                                    />
                                </div>
                                <div className='input mb-0 w-100'>
                                    <p className="text text-black font-m pb-3px">Security Code</p>
                                    <input type="text"
                                        className='form-control'
                                        name="SectionName"
                                        id="SectionName"
                                    />
                                </div>
                            </div>

                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Name on Card</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>
                            <div className='input mb-0'>
                                <p className="text text-black font-m pb-3px">Country</p>
                                <input type="text"
                                    className='form-control'
                                    name="SectionName"
                                    id="SectionName"
                                />
                            </div>

                        </div>

                        <div className="d-flex justify-content-end pt-10">
                            <button className="btn btn-orange px-3 h-100 fs-14 rounded py-1-5">Pay Now</button>
                        </div>
                    </div>


                </div>

                <div className="hs_footer d-flex flex-column justify-content-center align-items-center">
                    <p className="heading ar-light-color lh-24">STAR HEALTHCARE TECHNOLOGIES,  All Rights Reserved.</p>
                    <p className="text ar-light-color lh-24">
                        <a href="https://starhealthcare.co/PrivacyPolicy" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">Privacy Policy</a> | <a href="https://starhealthcare.co/BusinessAssociateAgreement" target="blank" className="text ar-light-color text-decoration-none ar-hover-text">BAA</a>.
                    </p>
                </div>


            </div> */}

            {/* <div className="ar_add_payment_detail_screen d-flex flex-column gap-20">
                <div className="practice_header d-flex align-items-center justify-content-between">
                    <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} className="w-max-content" crossOrigin="anonymous" />
                    <div className="d-flex flex-column">
                        <p className="heading fs-16 text-black">NORTHWEST CARE</p>
                        <p className="text clr-363C45">5911 4TH AVE, BROOKLYN, NY, 112204046</p>
                        <p className="text clr-363C45">contactabc@abcpractice.com | (643) 678-0987</p>
                    </div>
                </div>

                <div className="d-flex justify-content-center">
                    <div className="d-flex flex-column gap-20 add-payment-detail">
                        <div className="d-flex flex-column gap-6 text-center">
                            <p className="heading fs-25 balck-5-clr">Add Payment Details</p>
                            <p className="text fs-13 balck-5-clr">Enter your card details below to complete your payment securely.</p>
                        </div>
                        <div className="payment-detail-box d-flex flex-column gap-12 p-2">
                            <div className="d-flex align-items-center justify-content-between">
                                <p className='heading fs-16 orange-drk '>$90.00</p>
                                <p className='text font-m text-decoration-underline cursor-pointer'>Hide Details</p>
                            </div>
                            <div className="d-flex flex-column gap-6">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-1">
                                        <p className="heading text-black">10/29/2026</p>
                                        <p className="text text-black">30fff - Procedure for urgent visit</p>
                                    </div>
                                    <p className="text text-black">$10.00</p>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-1">
                                        <p className="heading text-black">10/29/2026</p>
                                        <p className="text text-black">30fff - Procedure for urgent visit</p>
                                    </div>
                                    <p className="text text-black">$10.00</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-10">
                            <div className="d-flex flex-column gap-5">
                                <label className="ar_radio-btn d-flex align-items-center gap-6">
                                    <input
                                        type="radio"
                                        id="Group"
                                    />
                                    <p className="text ar-orange-text" htmlFor="Group">Use Saved Card</p>
                                </label>

                                <div className="save-card-detail p-2 d-flex align-items-center gap-12">
                                    <div className=''>
                                        <img src='/assets/images/Visa.svg' alt="" />
                                    </div>
                                    <div className="">
                                        <p className="heading text-black lh-14">**** **** **** 0005</p>
                                        <p className="text text-black lh-14">Exp: 02/2023</p>
                                    </div>
                                </div>
                            </div>

                            <div className="or-content d-flex align-items-center gap-20">
                                <div className="ar-line w-100"></div>
                                <p className="text fs-13 ar-light-color text-nowrap">OR</p>
                                <div className="ar-line w-100"></div>
                            </div>

                            <div className="d-flex flex-column gap-5">
                                <label className="ar_radio-btn d-flex align-items-center gap-6">
                                    <input
                                        type="radio"
                                        id="Group"
                                    />
                                    <p className="text ar-orange-text" htmlFor="Group">Add New Card</p>
                                </label>

                                <div className="d-flex flex-column gap-10">
                                    <div className='input mb-0'>
                                        <label className='text-black fs-13'>Email</label>
                                        <input type="text"
                                            className='form-control'
                                            name="SectionName"
                                            id="SectionName"
                                        />
                                    </div>

                                    <div className='input mb-0'>
                                        <label className='text-black fs-13'>Cardholder Name</label>
                                        <input type="text"
                                            className='form-control'
                                            name="SectionName"
                                            id="SectionName"
                                        />
                                    </div>

                                    <div className='input mb-0'>
                                        <label className='text-black fs-13'>Card Number</label>
                                        <div className="position-relative card-number-input">
                                            <input type="text"
                                                className='form-control'
                                                name="SectionName"
                                                id="SectionName"
                                            />
                                            <div className='d-flex gap-5 align-items-center position-absolute translate-middle-y top-50 end-0'>
                                                <img src='/assets/images/MasterCard.svg' alt="" />

                                                <img src='/assets/images/Visa.svg' alt="" />

                                                <img src='/assets/images/AmericanExpress.svg' alt="" />

                                                <img src='/assets/images/UnionPay.svg' alt="" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex align-items-center gap-12">
                                        <div className='input mb-0 w-100'>
                                            <label className='text-black fs-13'>Expiration Date</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SectionName"
                                                id="SectionName"
                                            />
                                        </div>
                                        <div className='input mb-0 w-100'>
                                            <label className='text-black fs-13'>Security Code</label>
                                            <input type="text"
                                                className='form-control'
                                                name="SectionName"
                                                id="SectionName"
                                            />
                                        </div>
                                    </div>

                                    <div className='input'>
                                        <label className='text-black fs-13'>Country or Region</label>
                                        <SuperSearchList
                                            type="client"
                                            id='ProviderID'
                                            name='ProviderID'
                                            icon={'Simple'}
                                            sup_btn='sup_btn-Inp'
                                            sup_inp='superSearchVisitInp'
                                        />
                                    </div>

                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input type="checkbox"
                                                className="form-check-input m-0 p-0"
                                            />
                                        </div>
                                        <p className="text text-black fs-13 lh-1">Save my information for future payments.</p>
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div className="w-100">
                            <div className="btn btn-orange h-100 py-2 lh-normal w-100 rounded d-flex align-items-center justify-content-center">Pay Now</div>
                        </div>
                    </div>
                </div>
                <div className="ar_footer d-flex align-items-center justify-content-center">
                    <p className="heading ar-light-color">{ThemeConfiguration?.configuration?.company?.name},  All Rights Reserved.</p>
                </div>
            </div> */}

            {/* <div className="ar_payment_receipt_print d-flex flex-column gap-50">
                <div className="ar_orange-header d-flex align-items-center justify-content-center">
                    <p className="text text-decoration-underline fs-14 font-m text-white user-select-none cursor-pointer">Print Receipt</p>
                </div>

                <div className="d-flex justify-content-center pb-3">
                    <div className="ar_native_pdf_design ar_print-Payment_Receipt p-40 d-flex flex-column row-gap-30">
                        <div className="practice_header d-flex flex-column gap-16">
                            <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} className="w-max-content" crossOrigin="anonymous" />
                            <div className="d-flex justify-content-between align-items-end">
                                <div className="d-flex flex-column gap-6">
                                    <p className="heading fs-18 text-black">NORTHWEST CARE</p>
                                    <p className="text fs-14 clr-363C45">5911 4TH AVE, BROOKLYN, NY, 112204046</p>
                                    <p className="text fs-14 clr-363C45">contactabc@abcpractice.com | (643) 678-0987</p>
                                </div>

                                <div className="d-flex flex-column gap-6">
                                    <div className="d-flex align-items-center gap-16">
                                        <p className="text clr-363C45">Receipt #</p>
                                        <p className="text fs-14 text-black">213938249839483</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-16">
                                        <p className="text clr-363C45">Date Paid</p>
                                        <p className="text fs-14 text-black">Nov 16, 2026</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="billed-box-content d-flex flex-column gap-5">
                            <p className="text font-m fs-16 orange-drk">Billed To:</p>
                            <div className="d-flex flex-column gap-10">
                                <p className="heading text-black fs-18">John Hawk</p>
                                <p className="text fs-14 text-black">5911 4TH AVE, BROOKLYN, NY, 112204046</p>
                                <div className="d-flex align-items-center gap-1">
                                    <p className="text fs-14 text-black">Amount Paid:</p>
                                    <p className="heading fs-14 text-black">$10.00</p>
                                </div>
                                <p className="text fs-14 text-black">Payment Method: VISA - 4242</p>
                            </div>
                        </div>
                        <div className="">
                            <div className="ar_table">
                                <table className="w-100">
                                    <thead>
                                        <tr>
                                            <th className="heading text-white text-nowrap">Date of Service</th>
                                            <th className="heading text-white text-nowrap">CPT</th>
                                            <th className="heading text-white">Description</th>
                                            <th className="heading text-white text-nowrap">Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text text-black">10/29/2025</td>
                                            <td className="text text-black">307FF</td>
                                            <td className="text text-black">ERA 02842934 Adj: 456 from...</td>
                                            <td className="text text-black">$0.00</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex flex-column align-items-end">
                                <div className="">
                                    <div className="total-amount-detail">
                                        <div className="">
                                            <div className="d-flex flex-column gap-4 mb-12">
                                                <div className="d-flex align-items-center gap-2">
                                                    <p className="text fs-14 clr-363C45 w-125px">Sub Total</p>
                                                    <p className="text fs-14 text-black min-w-107px">$20.00</p>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <p className="text fs-14 clr-363C45 w-125px">Amount Paid</p>
                                                    <p className="text fs-14 orange-drk min-w-107px">$10.00</p>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 balance-content">
                                                <p className="text fs-14 clr-363C45 w-125px">Balance</p>
                                                <p className="heading fs-18 text-black min-w-107px">$10.00</p>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="py-2 px-12 ps-4">
                                        <p className="text clr-363C45">If you have any question contact us at </p>
                                        <p className="text font-m orange-clr">abc@abcpractice.com</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div> */}

        </React.Fragment>
    )
}
export default Login



